<fieldset class="daisy-fieldset w-full">
  <legend class="daisy-fieldset-legend">Session</legend>
  @if (loading) {
  <span class="daisy-loading daisy-loading-spinner daisy-loading-sm"></span>
  } @else {
  <select
    [formControl]="sessionControl"
    class="daisy-select daisy-select-bordered w-full"
  >
    <option [value]="ALL_SESSIONS_VALUE">All Sessions</option>
    @for (session of pastSessions; track getSessionValue(session)) {
    <option [value]="getSessionValue(session)">
      {{ getSessionLabel(session) }}
    </option>
    }
  </select>
  } @if (pastSessions.length === 0 && !loading) {
  <p class="text-sm text-gray-500 mt-1">No past sessions found.</p>
  }
</fieldset>
